<template>
    <a
        :href="href"
        class="external-link"
        :class="{
            'primary-link': type === 'primary',
            'secondary-link': type === 'secondary',
        }"
        rel="external"
        target="_blank">
        {{ linkText }}
        <pendo-icon
            v-if="showLinkIcon"
            size="14"
            aria-hidden="true"
            type="external-link" />
    </a>
</template>

<script>
import { PendoIcon } from '@pendo/components-vue3';

export default {
    name: 'LearnMoreLink',
    components: {
        PendoIcon,
    },
    props: {
        href: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'primary',
            validator: (value) => ['primary', 'secondary'].includes(value),
        },
        showLinkIcon: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        linkText () {
            if(this.label) return this.label;

            return this.$t('learnMoreLink.Learn more');
        },
    },
};
</script>
<style lang="less" scoped>
.external-link {
    display: inline-flex;
    gap: 4px;
    flex-direction: row;
    align-items: center;
    text-decoration: none;
    font-size: 14px;
    justify-content: center;

    &:hover {
        text-decoration: underline;
    }

    &:focus {
        outline: var(--action-focus-ring-color) 2px solid;
        border-radius: var(--action-border-radius);
        outline-offset: var(--action-focus-ring-width);
    }

    &.primary-link {
        color: var(--action-text-primary-base);
    }

    &.secondary-link {
        color: var(--action-text-default-base);
    }
}
</style>
